import i18n from '@dms/i18n';

/**
 * Readable label of a template placeholder the preview reported as missing. A placeholder the
 * frontend does not know yet (added on the backend first) falls back to its code.
 */
export const getConsentTemplatePlaceholderLabel = (placeholder: string) =>
  i18n.t(`entity.gdpr.labels.placeholder.${placeholder}`, {defaultValue: placeholder});
